import styled, { css } from 'styled-components';
import { Table } from 'semantic-ui-react';
import { theme } from '../styles';

export const StyledTableCell = styled(Table.Cell)`
    ${({ expandEnabled }) => expandEnabled && 'cursor: pointer;'}
    ${({ expandToggled }) => expandToggled && css`
        position: relative;
        &:before {
            content: '';
            position: absolute;
            pointer-events: none;
            left: 0;
            top: 0;
            width: 100%;
            height: calc(100% + 1px);
            z-index: 1;
            border-width: 1px;
            border-style: solid;
            border-color: ${theme.primaryColor} ${theme.primaryColor} #FFF;
            border-top-left-radius: 4px !important;
            border-top-right-radius: 4px !important;
        }
    `}
`
